import { request } from "../utils/request.js"

export const fundAccount_findUnfrozenList = ( args) => request({
    url: 'fundAccount/findUnfrozenList',
    method: 'GET',
    showFailMessage: true,
    ...args
})

export const fundAccount_addNew = (pojo, args) => request({
    url: 'fundAccount/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccount_update = (pojo, args) => request({
    url: 'fundAccount/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccount_findPageForManage = (pojo, args) => request({
    url: 'fundAccount/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccount_findPageForSelect = (pojo, args) => request({
    url: 'fundAccount/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundAccount_changeFrozenStatus = (id, args) => request({
    url: 'fundAccount/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundAccount_findById = (id, args) => request({
    url: 'fundAccount/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/fundAccount.js